import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Variables } from './variables';
import { LocalStorageService } from './localstorage';
import { LoadingController, ToastController } from 'ionic-angular';
//import { LoginPage } from '../pages/login/login';
//import { NavController } from 'ionic-angular';

import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';

declare var fingerprint;
declare function encryptData(data): any;

class Guid {
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }
}

@Injectable()
export abstract class BaseComunicationProvider {

    logout() {
        
        //this.navCtrl.setRoot(LoginPage);
    }
    
    json: { 
        item: any, 
        status: string, 
        message: string 
    };

    requestResult: any = {
        Status: "",
        Message: "",
        IsTest: false,
        Item: {}
    };
 
    public abstract address: string;

    constructor(public http: HttpClient, public variables: Variables, public localStorage: LocalStorageService, public loadingCtrl: LoadingController, protected toastCtrl: ToastController)
    {

    }

    presentToast(message: string) {
        const toast = this.toastCtrl.create({
          message: message,
          duration: 350,
          showCloseButton: true,
          closeButtonText: "Ok",
          position: 'bottom'
        });
        toast.present();
    };

    getDevice() {
        return fingerprint.toString();
    }

    HttpPost(address, data, headers) {
        let loading = this.loadingCtrl.create();
        loading.present();
        return new Promise((resolve, reject) => {
            this.http.post(address, data, headers)
                .retry(this.variables.retry).timeout(this.variables.timeout)
                .subscribe(data => {
                    loading.dismiss();
                    this.requestResult = data;
                    if ((this.requestResult.IsTest !== undefined) && (this.requestResult.IsTest !== null) && (this.requestResult.IsTest)) {
                        this.presentToast("Teste!");
                    }
                    if(this.requestResult.Status == "success") {
                        resolve(this.requestResult);
                    } else if (this.requestResult.Status == "invalid_token") {
                        reject(this.requestResult);
                    } else {
                        reject(this.requestResult);
                    }
                }, err => {
                    loading.dismiss();
                    this.requestResult.IsTest = err.IsTest;
                    this.requestResult.Item = err;
                    this.requestResult.Status = "error";
                    this.requestResult.Message = err.message;   
                   // this.presentAlert("Erro",this.message.checkConnection );   
                   if ((this.requestResult.IsTest !== undefined) && (this.requestResult.IsTest !== null) && (this.requestResult.IsTest)) {
                        this.presentToast("Teste!");
                    }              
                    reject(this.requestResult);
                });
        });
    }

    createToken(token: string) {
        var result: string = encryptData(Guid.newGuid() + "#" + token + "#" + Guid.newGuid());
        return result;
    }

    isNull(object: any): boolean {
        return(object == null) || (object == 'undefined');
    }

    sendDataHttp(operation, data) {
        let headers = new HttpHeaders();
        headers = headers.append('Accept', 'application/json');
        headers = headers.append('content-type', 'application/json;charset=UTF-8');
        headers = headers.append('responseType', 'json');
        headers = headers.append("bdg-device", this.getDevice());
        headers = headers.append("bdg-version", Variables.version);
        headers = headers.append("bdg-operation", operation);
        if (Variables.championshipId > 0) {
            headers = headers.append("bdg-championship", Variables.championshipId.toString());
        }
        if (Variables.ticketId > 0) {
            headers = headers.append("bdg-ticket", Variables.ticketId.toString());
        }
        var userTxt = this.localStorage.getItem("user");
        if ((null != userTxt) && ('undefined' != userTxt)) {
            var user = null;
            try {
                user = JSON.parse(userTxt);
            }
            catch {

            }
            if (!this.isNull(user)) {
                headers = headers.append("bdg-token", this.createToken(user.Token));
            }
        }

        return new Promise((resolve, reject) => {
            if ((Variables.baseUrl != null) && (Variables.baseUrl.length > 0)) {
                let url = Variables.baseUrl + this.address;
                  this.HttpPost(url, data, { headers: headers })
                    .then(result => {
                        resolve(result);
                    })
                    .catch(err => {
                        this.requestResult.Item = err.Item;
                        this.requestResult.Status = err.Status;
                        this.requestResult.Message = err.Message;
                        reject(this.requestResult);
                    })
            } else {
                this.requestResult.Item = "";
                this.requestResult.Status = "error";
                this.requestResult.Message = "endereço base não informado";
                reject(this.requestResult);
            }
        });
    };

}


// WEBPACK FOOTER //
// ./src/providers/basecomunication.ts